import React,{useContext} from "react";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import moment from 'moment'
import {getWireTransferStatusIcon, getReasonDescription } from "../../utils/utilsWireTransfer"
import {formatAsMoney, getAnalysisStatusColor, 
        getAnalysisStatusSiglum, getAnalysisStatus, getAgencyInfo} from "../../utils/utils"
import { getTransactionDirectionIcon } from "../../../PIX/utils/utilsTransaction";
import Tooltip from "@material-ui/core/Tooltip";
import AuthContext from "../../../../context/auth-context";

function WireTransferCard(props){

    let is_fraud = (props.wire_transfer.fraud_status === "fraud")

    let counter_part_account_object = (props.wire_transfer.wire_transfer_direction === 'received' ? 
                            props.wire_transfer.source_account : 
                            props.wire_transfer.destination_account)


    let [institution_name] = getAgencyInfo (counter_part_account_object) 

    let {user_data} = useContext(AuthContext)

    let wire_transfer_type_dictionary = {
        ted: "TED", 
        doc: "DOC",
        internal_transfer: "Transferência Interna",
        contribution: "Aporte",
        redemption: "Resgate"
    }       

    return (
        <Card className="listCard">
            <Link
                className={
                    is_fraud ? 
                    ["listCardItem", "linkRed", "subtitleSize", "breakWord", "bold"].join(" ")
                    :
                    ["listCardItem", "link", "subtitleSize", "breakWord", "bold"].join(" ")}
                style={{flex:"1 1 110px", textAlign:"center"}}
                to={"/wire-transfer/" + props.wire_transfer.wire_transfer_key}
            >
                {is_fraud ?
                    <Tooltip title={<p className="tooltipText">Transação reportada como fraude</p>}>
                        <div style={{display:"flex", justifyContent: "center", alignItems: "center"}}>
                            {props.wire_transfer.id}
                        </div>
                    </Tooltip> :
                    <div>
                        {props.wire_transfer.id}
                    </div>
                    }
            </Link>
            {user_data.business_group_key &&
            <div 
                className={["listCardItem", "normalText"].join(" ")}
                style={{flex:"1 1 80px", textAlign:"center"}}
            >
                {props.wire_transfer.company_name}
            </div>}
            <div 
                className={["listCardItem", "normalText", "normalMediumSize"].join(" ")} 
                style={{flex:"1 1 130px", textAlign:"center"}}  
            >
                {formatAsMoney(props.wire_transfer.amount, "-")}
            </div>
            <div 
                className={["listCardItem", "normalText", "normalMediumSize"].join(" ")}
                style={{flex:"1 1 100px", textAlign:"center"}}
            >
                {(props.wire_transfer.wire_transfer_direction==='received')?((props.wire_transfer.destination_account.owner || {}).document_number || "-"):(props.wire_transfer.source_account.owner || {}).document_number || "-"}
            </div>
            <div 
                className={["listCardItem", "normalText", "normalMediumSize"].join(" ")} 
                style={{flex:"1 1 45px", textAlign:"center"}}  
            >
                {getTransactionDirectionIcon (props.wire_transfer.wire_transfer_direction, "small", true)}
            </div>
            <div 
                className={["listCardItem", "normalText", "normalMediumSize"].join(" ")} 
                style={{flex:"1 1 100px", textAlign:"center"}}  
            >
                {wire_transfer_type_dictionary[props.wire_transfer.wire_transfer_type]}                     
            </div>
            <div 
                className={["listCardItem", "normalText", "normalMediumSize"].join(" ")} 
                style={{flex:"1 1 100px", textAlign:"center"}}  
            >
                {institution_name ? 
                <Tooltip title={<p className="tooltipText">{institution_name}</p>}>
                    <div style={{display:"flex", justifyContent:"center"}}>
                        <div className={["textOverflow","centerText","labelSpace"].join(" ")}>{institution_name}</div>
                    </div>
                </Tooltip> : (counter_part_account_object || {}).participant}
            </div>
            <div 
                className={["listCardItem", "normalText", "normalMediumSize", "bold"].join(" ")} 
                style={{flex:"1 1 45px", textAlign:"center", cursor: "default"}}  
            >
                <Tooltip title={<p className="tooltipText" style={{textAlign: "center"}}>
                    {getAnalysisStatus(props.wire_transfer.analysis_status)}
                    <br/>{getReasonDescription(props.wire_transfer)}
                </p>}>
                <div className={["circle", "small"].join(" ")} style={{backgroundColor:getAnalysisStatusColor(props.wire_transfer.analysis_status)}}>
                    {getAnalysisStatusSiglum(props.wire_transfer.analysis_status)}
                </div>
                </Tooltip>
            </div>
            <div 
                className={["listCardItem", "normalText", "normalMediumSize"].join(" ")}
                style={{flex:"1 1 110px", textAlign:"center"}}
            >
                {moment(props.wire_transfer.wire_transfer_date).format("DD/MM/YYYY HH:mm:ss")}
            </div>
            <div 
                className={["listCardItem", "normalText", "normalMediumSize", "bold"].join(" ")}  
                style={{flex:"1 1 35px", textAlign:"center", cursor: "default"}}  
            >
                {getWireTransferStatusIcon(props.wire_transfer.wire_transfer_status, "small", true)}
            </div>
        </Card>
    )
}

export default WireTransferCard